import { z } from 'zod/mini'

// zod/mini is tree-shakable: keeps validation out of the critical path's bundle weight.
const schema = z.object({
  VITE_API_URL: z._default(z.url(), 'http://localhost:8000'),
  VITE_APP_NAME: z._default(z.string().check(z.minLength(1)), 'OneMentor'),
})

/** Validated build-time config. Fails loudly at startup instead of mid-session. */
export const env = (() => {
  const parsed = schema.safeParse(import.meta.env)
  if (!parsed.success) {
    throw new Error(`Invalid frontend environment: ${z.prettifyError(parsed.error)}`)
  }
  return Object.freeze(parsed.data)
})()
